export default "__VITE_ASSET__CJoVKoNo__"